import { apiClient } from '@/lib/api/client';
/** Access portal for a passenger without OTP (admin-authenticated flow) */
export async function accessPortalAsPassenger(tenantSlug, passengerId, accessToken) {
    const { data } = await apiClient.post('/api/v1/portal/access', {
        tenantSlug,
        passengerId,
        accessToken,
    });
    return data;
}
//# sourceMappingURL=portal.js.map